import React, { useState, useEffect } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';
import API from '../../api';
import Tools from '../../tools';
import ListViewEven from '../utils/ListViewEven';
import Enums from '../../enums';
import Loading from '../Loading';

export default function ProjAnswerRecord(props) {
    const [isFetched, setIsFetched] = useState(false);
    const [answerDataList, setAnswerDataList] = useState([]);
    const [answerHeaderList, setAnswerHeaderList] = useState([]);
    const [sortType, setSortType] = useState([]);
    const [hideIndexList, setHideIndexList] = useState([]);
    const [isLoading, setIsLoading] = useState([]);


    useEffect(() => {
        // console.log("updated", isFetched);
        if (false == isFetched) {
            API.init({ props });
            Tools.init();
            getData();
        }
        setIsFetched(true);
    }, [isFetched]);

    function getData() {
        setIsLoading(true);
        let tmpData = {
            pi: props.pi
        };
        API.GetAnswerRecord(tmpData).
            then(onDataUpdated);
        // onDataUpdated({ "data": [{ "platform_point": 3000, "item_id": "IT210809111838", "item_type": "後台點數", "price": 15000, "item_name": "基礎版 15,000元(3000點)", "item_description": "適合偶爾了解市場訊息，議題很單純，想快速、小規模回收問卷的團隊" }, { "platform_point": 6000, "item_id": "IT210809112018", "item_type": "後台點數", "price": 27000, "item_name": "行銷版 27,000元(6000點)", "item_description": "適合所有行銷、客戶服務、計畫提案團隊，各項方案推行前率先掌握市場資訊" }, { "platform_point": 12000, "item_id": "IT210809112146", "item_type": "後台點數", "price": 48000, "item_name": "企業版 48,000元(12000點)", "item_description": "適合大型企業、有定期產品開發、企劃設計需求，固定週期蒐集消費者反饋" }] });
    }

    function onDataUpdated(data) {
        setIsLoading(false);
        // console.log("[!]", data);
        // setIsAdmin(API.getIsAdmin());
        if (data && data.responseData
            && data.responseData.data && data.responseData.data.length > 0) {
            // console.log(data.responseData.data);
            // console.log(data.responseData.header);
            if (setSortType.length == 0) {
                setSortType(Array(data.responseData.data.length).fill(Enums.ESORT.STR));
                setHideIndexList(Array(data.responseData.header.length).fill(false));
            }

            let tmpList = [];
            data.responseData.data.forEach((tmpObj, index) => {
                tmpList.push({
                    key: index,
                    data: [...tmpObj]
                });
            });
            setAnswerDataList(tmpList);
            let tmpHeader = ["ID"];
            for( let i=1; i<data.responseData.header.length; i++){
                tmpHeader.push("Q"+(i));
            };
            setAnswerHeaderList(tmpHeader); //data.responseData.header
            // props.cookies.set('usr', data.display_name, { path: '/' });
        }
        // setIsInit(true);
    }

    // constructor(props) {
    //     super(props);

    //     onChange = onChange.bind(this);
    //     onAdd = onAdd.bind(this);
    // }

    // function onChange(i, url) {
    //     // onChange(i, event) {
    //     // console.log(event.target, i);
    //     // let tmp = props.value;
    //     // tmp[i] = event.target.value;
    //     // props.onChange(props.dataKey, tmp);
    //     let tmp = props.value;
    //     tmp[i] = url;
    //     console.log(props.dataKey, tmp);
    //     props.onChange(props.dataKey, tmp);
    // }

    // function onAdd(event) {
    //     console.log(event.target);
    //     props.onChange(props.dataKey, props.value ? props.value.concat('') : [""]);
    // }

    // function onClickDownload(id, e) {
    //     e.stopPropagation();
    //     e.preventDefault();
    //     console.log("onClickDownload", id);

    //     API.GetAnswerRecordCSV({
    //         pi: id
    //     }).then(response => {
    //         console.log(response);

    //         if (response && response.response && response.response.status == 200) {
    //             var link = document.createElement('a');
    //             link.href = window.URL.createObjectURL(response.responseData);
    //             link.download = "GetAnswerRecordContentCSV.csv";
    //             link.click();
    //         } else {
    //             alert("資料下載錯誤");
    //         }
    //     }) // JSON from `response.json()` call
    //         .catch(error => console.error(error));
    //     // window.open(this.props.history.createHref("/proj/add?pid=" + index));
    // }

    function render() {
        return (
            <div className="Row">
                <ListViewEven list={(null != answerDataList) ? answerDataList : []}
                    sort_type={sortType}
                    fields={(null != answerHeaderList) ? answerHeaderList : []}
                    title={"下載填答結果"}
                    onRowClicked={null}
                    sort_index={0}
                    ascending={true}
                    fileName={"answerRecord_" + props.pi}
                    hideIndexList={hideIndexList}
                    renderDownload={null}
                />
                <Loading isLoading={isLoading} />
            </div>
        );
    }
    return render();
}